
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'
import {urlCall3cx, freshdeskBaseUrl} from '@/config/service'

const prospectModule = namespace('prospect')
const contactModule = namespace('contact')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer,
    FaRating
  }
})
export default class ProspectContact extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @contactModule.Action('deleteContactAction') deleteContact: any

  thumbsUp = null

  get icon() {
    return this.thumbsUp
  }

  created() {
    this.thumbsUp = ThumbsUp
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du contact ?', optionsVslim)
    if (ok) {
      this.deleteContact(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }

  link3cx(tel) {
    return `${urlCall3cx}?phone=${tel}`
  }

  linkFreshdesk(id) {
    return `${freshdeskBaseUrl}/a/contacts/${id}`
  }

  hasPositionnements(item) {
    return (
      item.POSTIONNEMENT_DECISIONNAIRE === 1 ||
      item.POSTIONNEMENT_ANALYSTE === 1 ||
      item.POSTIONNEMENT_COMPTABLE === 1 ||
      item.POSTIONNEMENT_TRAVAUX === 1 ||
      item.POSTIONNEMENT_INFORMATIQUE === 1 ||
      item.POSTIONNEMENT_COMMUNICATION === 1
    )
  }

  getPositionnements(item) {
    const p = []
    if (item.POSTIONNEMENT_DECISIONNAIRE === 1) p.push(' Decisionnaire')
    if (item.POSTIONNEMENT_ANALYSTE === 1) p.push(' Analyste')
    if (item.POSTIONNEMENT_COMPTABLE === 1) p.push(' Comptable')
    if (item.POSTIONNEMENT_TRAVAUX === 1) p.push(' Travaux')
    if (item.POSTIONNEMENT_INFORMATIQUE === 1) p.push(' Informatique')
    if (item.POSTIONNEMENT_COMMUNICATION === 1) p.push(' Communication')
    return p.toString()
  }
}
